import styled from 'styled-components';

import { Table } from '@dreryk/react-components';

export const StyledHistoricalLeavesTable = styled(Table)`
   height: 100%;
` as typeof Table;
